module.exports = __webpack_public_path__ + "static/asi-empieza-c986ac84ceef89a687a6bda74968ee0b.png";